import { useEffect, useRef } from "react";

export function useVisualViewport() {
  const stableHeightRef = useRef(0);

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;

    stableHeightRef.current = window.innerHeight;
    let rafId = 0;
    let lastKeyboardHeight = 0;

    const onViewportChange = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        const currentStable = stableHeightRef.current;
        const diff = currentStable - vv.height;
        const keyboardHeight = diff > 80 ? Math.round(diff) : 0;

        if (keyboardHeight !== lastKeyboardHeight) {
          lastKeyboardHeight = keyboardHeight;
          document.documentElement.style.setProperty(
            "--keyboard-height",
            keyboardHeight > 0 ? `${keyboardHeight}px` : "0px"
          );
        }
      });
    };

    const recalibrate = () => {
      setTimeout(() => {
        stableHeightRef.current = window.innerHeight;
        onViewportChange();
      }, 300);
    };

    const onWindowResize = () => {
      if (!document.activeElement || document.activeElement === document.body) {
        stableHeightRef.current = window.innerHeight;
      }
    };

    vv.addEventListener("resize", onViewportChange);
    window.addEventListener("orientationchange", recalibrate);
    window.addEventListener("resize", onWindowResize);

    return () => {
      cancelAnimationFrame(rafId);
      vv.removeEventListener("resize", onViewportChange);
      window.removeEventListener("orientationchange", recalibrate);
      window.removeEventListener("resize", onWindowResize);
      document.documentElement.style.removeProperty("--keyboard-height");
    };
  }, []);
}
